// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBar_container__256YW","search":"SearchBar_search__4L5oy","refresh":"SearchBar_refresh__3okKZ","btnFavorite":"SearchBar_btnFavorite__1xRQ3"};